const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPromotions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0418428,0,0,0.0418428,0.0636528,0.268066)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.845559,0,0,0.788032,53.3476,112.022)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.831,213.635L256,150.378L65.169,213.635L0.01,317.135L59.995,337.02L59.995,447.029L255.999,512L452.003,447.029L452.003,337.02L511.988,317.135L446.831,213.635M389.33,226.18L251.591,274.677L121.058,231.408L251.591,188.139L389.33,226.18M45.803,300.709L80.683,248.967L229.175,298.19L194.296,353.595L45.803,304.373M89.07,349.659L206.893,388.715L236.906,341.042L236.906,475.422L89.07,426.417L89.07,349.659M266.277,475.421L266.277,341.041L296.29,388.714L414.113,349.658L414.113,426.416L266.277,475.421M308.887,353.596L274.008,298.191L422.499,248.968L457.38,304.374L308.887,353.596",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.816043,0.119418,-0.119418,0.816043,24.418,-21.4607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.073,3.459C140.557,125.764 122.304,144.016 0,166.532C122.305,189.048 140.557,207.3 163.073,329.605C185.589,207.3 203.841,189.048 326.146,166.532C203.841,144.016 185.588,125.764 163.073,3.459Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.846245,0.123837,-0.123837,0.846245,167.471,-173.021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.064,232.896C325.746,310.677 314.136,322.286 236.356,336.604C314.136,350.923 325.746,362.532 340.064,440.312C354.382,362.532 365.992,350.922 443.771,336.604C365.99,322.286 354.383,310.677 340.064,232.896Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotions);
export default __webpack_public_path__ + "static/media/promotions.d94293ab3fff35a2b5ab8d9c1f598344.svg";
export { ForwardRef as ReactComponent };